import { Styles } from 'assets/types';
import tableFirstStyles from 'assets/stylesheets/defaultStyles/tableFirst.style';

const chapterListTableStyles: Styles = theme => ({
  ...tableFirstStyles(theme),
});

export default chapterListTableStyles;
